import api from "../../../api.js";

export async function fetchPendingChronicCards({ search = "", date = "", branchcode } = {}) {
  const res = await api.get("/dispensary/chronic/pending", {
    params: {
      ...(search ? { search } : {}),
      ...(date ? { date } : {}),
      ...(branchcode ? { branchcode } : {}),
    },
  });
  return res.data?.data || [];
}

